export enum SysMemberFieldKey {
    Nickname = '_widget_0300000000001',
    Username = '_widget_0300000000002',
    Phone = '_widget_0300000000003',
    Email = '_widget_0300000000004',
    Dept = '_widget_0300000000005',
    Role = '_widget_0300000000006'
}

export enum PresetMemberFieldKey {
    Alias = '_widget_0300000000011', // 别名
    Gender = '_widget_0300000000012', // 性别
    JobNumber = '_widget_0300000000013' // 工号
}

export enum MemberFieldValueType {
    Text = 'text',
    Datetime = 'datetime',
    DeptGroup = 'deptgroup',
    RoleGroup = 'rolegroup',
    Number = 'number',
    Dept = 'dept',
    User = 'user',
    UserGroup = 'usergroup',
    Combo = 'combo',
    ComboCheck = 'combocheck'
}

export enum MemberFieldSource {
    System = 'system',
    Preset = 'preset',
    Custom = 'custom'
}

export interface MemberFieldOption {
    text: string;
    value: string;
    selected?: boolean;
}

// 前端消费侧的字段定义
export interface MemberField {
    label: string; // 标题
    key: string; // key
    valueType: string; // 类型
    required?: boolean; // 必填
    maxWordCount?: number; // 最大字符数
    format?: string; // 格式
    emptyValue: any; // 空值
    defaultValue: any; // 默认值
    options?: MemberFieldOption[]; // 选项
}

// 后端配置侧的字段原始结构
export interface MemberFieldApiData {
    widget_name: string;
    name: string;
    type: string;
    source: string;
    required: boolean;
    status: string;
    seq: number;
    items: MemberFieldOption[];
    account_setting: {
        visible: boolean;
        editable: boolean;
    };
    member_card: {
        visible: boolean;
    };
}
